import { render } from "./Inlet.vue?vue&type=template&id=aafa38fc&scoped=true"
import script from "./Inlet.vue?vue&type=script&lang=js"
export * from "./Inlet.vue?vue&type=script&lang=js"

import "./Inlet.vue?vue&type=style&index=0&id=aafa38fc&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aafa38fc"]])

export default __exports__